import classnames from "classnames";
import { ChangeEvent } from "react";
import "./Input.scss";

export interface ISingleSelectInputProps {
  className?: string;
  checked: boolean;
  label: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLInputElement>, value: string) => void;
}

export const SingleSelectInput = ({
  checked,
  label,
  className,
  value,
  onChange,
}: ISingleSelectInputProps) => {
  const classes = classnames("InputOption", className, {
    "InputOption--selected": checked,
  });

  return (
    <div className={classes}>
      <input
        className="InputOption__input"
        type="radio"
        id={value}
        checked={checked}
        value={value}
        onChange={(event) => onChange(event, value)}
      />
      <label className="InputOption__label" htmlFor={value}>
        {label}
        <span className="InputOption__input__dot"></span>
      </label>
    </div>
  );
};
